import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "components/common/Dropdown";
import type { DropdownOption } from "components/common/Dropdown/types";
import type { ProjectScope } from "hooks/useProjectScope";
import type { ProjectScopeToggleProps } from "./types";

export const ProjectScopeToggle = ({
  scope,
  onScopeChange,
}: ProjectScopeToggleProps) => {
  const { t } = useTranslation();

  const scopeOptions: DropdownOption<ProjectScope>[] = useMemo(
    () => [
      { value: "organization", label: t("dashboard.scope.organization") },
      { value: "all", label: t("dashboard.scope.all") },
    ],
    [t],
  );

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm font-medium text-gray-500">
        {t("dashboard.filters")}
      </span>
      <Dropdown<ProjectScope>
        options={scopeOptions}
        value={scope}
        onChange={onScopeChange}
      />
    </div>
  );
};
